import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './app/store';
import 'react-toastify/dist/ReactToastify.css';
import { bootstrapSSO, ReCaptchaProvider } from 'keycloakauthmodule';
import { configureKeycloakAuthModule } from 'keycloakauthmodule';
import { BrowserRouter } from 'react-router-dom';

configureKeycloakAuthModule({
  baseURL: process.env.REACT_APP_API_SSO_BASE_URL!,
  imageBaseURL: process.env.REACT_APP_SSO_IMAGE_BASE_PATH!
});

// bootstrapSSO(store); // restore tokens / schedule refresh


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Provider store={store}>
    <React.StrictMode>
      <BrowserRouter>
        <ReCaptchaProvider>
          <App />
        </ReCaptchaProvider>
      </BrowserRouter>
    </React.StrictMode>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
